export default __webpack_public_path__ + "static/media/green_4.547c5df1.png";